import '../../index.css';
function PortfolioContainer(props) {
	return (
		<>
			{/* <Tabs></Tabs> */}
			<div className='content p-0 m-1' id='datepickerportal'>
			{/* <div className='content p-0 mx-1' id='datepickerportal'> */}
				{props.children}
			</div>
		</>
	);
}

export default PortfolioContainer;
